import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from 'src/app/auth/auth.guard';
import { UserRoles } from 'src/app/auth/auth.model';
import { RoleGuard } from 'src/app/auth/role.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import {
  ALUNNO_SLUG,
  CPI_SLUG,
  DOCENTE_SLUG,
  ENTE_SLUG,
  PRESIDENTE_SLUG,
  REGIONE_SLUG,
  TUTOR_SLUG,
} from './logged.routes';

const routes: Routes = [
  {
    path: '',
    canActivate: [AccessGuard],
    component: DashboardComponent,
  },
  {
    path: CPI_SLUG,
    loadChildren: () => import('./cpi/cpi.module').then((m) => m.CpiModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.CPI },
  },
  {
    path: REGIONE_SLUG,
    loadChildren: () =>
      import('./regione/regione.module').then((m) => m.RegioneModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.REGIONE },
  },
  {
    path: ENTE_SLUG,
    loadChildren: () => import('./ente/ente.module').then((m) => m.EnteModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.ENTE },
  },
  {
    path: ALUNNO_SLUG,
    loadChildren: () =>
      import('./alunno/alunno.module').then((m) => m.AlunnoModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.CITTADINO },
  },
  {
    path: DOCENTE_SLUG,
    loadChildren: () =>
      import('./docente/docente.module').then((m) => m.DocenteModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.DOCENTE },
  },
  {
    path: PRESIDENTE_SLUG,
    loadChildren: () =>
      import('./presidente/presidente.module').then((m) => m.PresidenteModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.PRESIDENTE },
  },
  {
    path: TUTOR_SLUG,
    loadChildren: () =>
      import('./tutor/tutor.module').then((m) => m.TutorModule),
    canActivate: [RoleGuard],
    runGuardsAndResolvers: 'always',
    data: { role: UserRoles.TUTOR },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoggedRoutingModule {}
